import { authInstance } from '../login/AuthService';
export default class Service {

    constructor(baseUrl) {
        this.baseUrl = baseUrl || `https://astcloudrestservice.azurewebsites.net/api`;
        this.Auth = authInstance;
    }

    getClientName() {
        //document.getElementById("Loading").className = "";
        //fetch('https://simulateapiprod.azurewebsites.net/api/clients', {
        return fetch('https://astcloudrestservice.azurewebsites.net/api/clients', {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${this.Auth.getToken()}`
            },
        })
        .then(results => results.json())
    }

    getMap(EPGuid){
        return fetch(this.baseUrl+'/clients/'+EPGuid, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${this.Auth.getToken()}`
            },
        }).then(results => {
            return results.json();
        })
    }

    processFile(formData){
        return fetch(this.baseUrl+'/predict/processfile',{
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.Auth.getToken()}`
              },
            body: formData,
        }).then(results => {
            return results.json();
        })
    }
}
export const service = new Service();